import createModalModel, { prop } from './lib/create_modal_model';

export default createModalModel({
  modelName: 'RedactConversationItem',
  properties: {
    itemId: prop(String),
    customerId: prop(String),
  },
});
